import React, { useMemo } from 'react';
import { Box } from '@mantine/core';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getWaterFlowRateListQuery } from '../../../slices/waterFlowRateList/thunk';

const AuthorizedWaterDistributionPanel = ({ waterRightData }) => {
	
	const columns = useMemo(
		() => [
			{
				header: 'Ejercicio del Derecho',
				dataType: 'select',
				accessorKey: 'right_exercise_type.name',
			},
			{
				header: 'Unidad de Agua Autorizada',
				dataType: 'select',
				accessorKey: 'flow_rate_unit.name',
			},
			{
				header: 'Fuente de Agua',
				dataType: 'select',
				accessorKey: 'water_source.name',
			},
			{
				header: 'Enero',
				dataType: 'number',
				accessorKey: 'january',
			},
			{
				header: 'Febrero',
				dataType: 'number',
				accessorKey: 'february',
			},
			{
				header: 'Marzo',
				dataType: 'number',
				accessorKey: 'march',
			},
			{
				header: 'Abril',
				dataType: 'number',
				accessorKey: 'april',
			},
			{
				header: 'Mayo',
				dataType: 'number',
				accessorKey: 'may',
			},
			{
				header: 'Junio',
				dataType: 'number',
				accessorKey: 'june',
			},
			{
				header: 'Julio',
				dataType: 'number',
				accessorKey: 'july',
			},
			{
				header: 'Agosto',
				dataType: 'number',
				accessorKey: 'august',
			},
			{
				header: 'Septiembre',
				dataType: 'number',
				accessorKey: 'september',
			},
			{
				header: 'Octubre',
				dataType: 'number',
				accessorKey: 'october',
			},
			{
				header: 'Noviembre',
				dataType: 'number',
				accessorKey: 'november',
			},
			{
				header: 'Diciembre',
				dataType: 'number',
				accessorKey: 'december',
			},
		],
		[]
	);

	return (
		<Box
			className='p-2'
			sx={{
				display: 'Grid',
				margin: 'auto',
				width: '100%',
			}}
		>
			<ODataGrid
				columns={columns}
				getDataFunc={getWaterFlowRateListQuery}
				baseFilters={{
					water_right_id: { $eq: waterRightData._id },
					disable: { $eq: false },
				}}
				queryPopulate={['right_exercise_type', 'flow_rate_unit', 'water_source']}
				remoteOperations={{
					pagination: true,
					sorting: true,
					filtering: true,
				}}
				nameFile='distribucion_agua_autorizada'
				getRowIdTable={(row) => row._id}
			/>
		</Box>
	);
};

export default AuthorizedWaterDistributionPanel;
